import React, { useMemo } from "react";
import BackIconIcon from "../../../../assets/images/backIcon.png";
import { useNavigate } from "react-router-dom";
import { GrClose } from "react-icons/gr";

// ----------------------------------------------------------------------------

export default function CloseIcon(props) {
  const { onClick, style } = props;
  const navigate = useNavigate();
  return (
    <div onClick={() => (onClick ? onClick() : navigate(-1))}>
      <GrClose style={{ width: 30, height: 30 }} />
    </div>
  );
}

// ----------------------------------------------------------------------------
